import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { RequisicaoFormComponent } from './requisicao-form/requisicao-form.component';
import { RequisicaoListComponent } from './requisicao-list/requisicao-list.component';
import { RequisicaoViewComponent } from './requisicao-view/requisicao-view.component';

const routes: Routes = [
  { path: '', component: RequisicaoListComponent, canActivate: [AuthGuard] },
  { path: 'novo', component: RequisicaoFormComponent, canActivate: [AuthGuard] },
  { path: ':id/editar', component: RequisicaoFormComponent, canActivate: [AuthGuard] },
  { path: ':id/visualizar', component: RequisicaoViewComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequisicaoRoutingModule { }
